import { makeStyles } from '@material-ui/core/styles';

export const useEditStyles = makeStyles({
  createBox: {
    marginTop: '25px',
    width: '100%',
    maxWidth: '1500px',
    '@media (max-width: 850px)': {
      marginTop: '0px',
      paddingLeft: '8px',
      paddingRight: '8px',
      boxSizing: 'border-box',
    },
  },
  mobileBorderlessWhiteBox: {
    marginBottom: '20px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid lightgray',
    padding: '10px',
    width: '100%',
    '@media (max-width: 850px)': {
      borderRadius: '0px',
      padding: '0px',
    },
  },
  tabs: {
    backgroundColor: '#026584',
  },
  tabsText: {
    fontSize: 14,
    '@media (max-width: 800px)': {
      fontSize: '12px',
    },
  },
  indicator: {
    backgroundColor: 'white',
  },
  titleTabNoBorder: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
  },
  titleFont: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
});